export default "<csn-livespins-room [liveStream]=\"liveStream\" [cta]=\"true\"></csn-livespins-room>"